import React, { PureComponent } from "react";
import _ from "lodash";

import { getUrlForValue } from "../../../actions/drive";
import { getSelectedActivityId } from "../../../actions/playerActions";
class RelatedItem extends PureComponent {
	render() {
		const { relatedItem } = this.props;
		if (!relatedItem) {
			return null;
		}
		const { title, backgroundImage } = relatedItem;
		let style = {
			position: "relative",
			minWidth: "240px",
			height: "180px",
			borderRadius: 10
		};

		if (backgroundImage) {
			const backgroundUrl = getUrlForValue(this.props.relatedItem.backgroundImage, getSelectedActivityId());
			style = _.assign({}, style, {
				backgroundImage: `url(${backgroundUrl})`,
				backgroundRepeat: "no-repeat",
				backgroundSize: "cover",
				backgroundPosition: "center"
			});
		}

		return (
			<div className="btn-related-item" onClick={this.props.onClick} style={{cursor: "pointer"}}>
				<div
					style={style}>
					<div style={{ borderRadius: 10, position: "absolute", top: 0, left: 0, bottom: 0, right: 0, padding: 10, backgroundColor: "rgb(40,94,161)", opacity: 0.65 }} />
					<div style={{ position: "absolute", top: 0, left: 0, bottom: 0, right: 0, padding: 10, color: "white", fontWeight: "bold", fontSize: 18 }}><span>{title}</span></div>
				</div>
			</div>
		);			
	}
}

export default RelatedItem;